import { defineStore } from 'pinia'
import { ref } from 'vue'
import { runSeo, ApiRequestError } from '@/api/client'
import type { Report } from '@/api/schemas'

export const useSeoStore = defineStore('seo', () => {
  const status = ref<'idle' | 'running' | 'success' | 'error'>('idle')
  const report = ref<Report | null>(null)
  const error = ref<string>('')
  const lastDomain = ref<string>('')
  const auditId = ref<number | null>(null)

  async function submit(domain: string, email: string) {
    status.value = 'running'
    error.value = ''
    auditId.value = null
    try {
      const res = await runSeo(domain, email)
      report.value = res.report
      lastDomain.value = res.report.host
      auditId.value = res.audit_id
      status.value = 'success'
    } catch (e) {
      const msg =
        e instanceof ApiRequestError ? e.message : 'Something went wrong running the SEO audit.'
      error.value = msg
      status.value = 'error'
      auditId.value = null
    }
  }

  function reset() {
    status.value = 'idle'
    report.value = null
    error.value = ''
    lastDomain.value = ''
    auditId.value = null
  }

  return { status, report, error, lastDomain, auditId, submit, reset }
})
